import { styled } from '@material-ui/core';

const BlankButton = styled('div')({
  textAlign: 'start',
  background: 'none',
  color: 'inherit',
  border: 'none',
  padding: 0,
  font: 'inherit',
  cursor: 'pointer',
  outline: 'inherit',
});

export { BlankButton };
